// extracted by mini-css-extract-plugin
export var closeButton = "_25-0";